export default __webpack_public_path__ + "static/media/icon__facebook.7e1d79ac.svg";